import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

const Experties = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const counters = document.querySelectorAll(".metric-number");
    const speed = 200;

    counters.forEach((counter) => {
      const updateCount = () => {
        const target = +counter.getAttribute("data-target");
        const count = +counter.innerText;
        const inc = target / speed;

        if (count < target) {
          counter.innerText = Math.ceil(count + inc);
          setTimeout(updateCount, 1);
        } else {
          counter.innerText = target;
        }
      };

      updateCount();
    });
  }, []);
  return (
    <section className="experties-section">
      <Container>
        <Row>
          <Col md={4}>
            {/* <div className="image-container">
              <img
                loading="lazy"
                src={ImageOne}
                className="w-100"
                alt="Valuer"
              />
            </div> */}
            <div className="header">
              {/* <span className="newsletter-text">
                  Flexible supported learning
                </span> */}
              <h2 className="newsletter-title">
                <u>Our Current Standing in Valuation</u>
              </h2>
              <p className="newsletter-text">
                With decades of experience in the field of Valuation,
                fostering growth and advancement of the Valuation fraternity,
                and providing them with a common platform to raise their
                concerns with respect to the profession, IOV has always
                maintained its stand as an ethical Valuation body, working
                tirelessly towards guiding the Valuation professionals, and
                safeguarding them from indulging in mal-practices.
              </p>
            </div>
          </Col>
          <Col md={8}>
            <div className="content-container">
              <div className="scard">
                <div className="metrics-container">
                  <div className="metric-card" onClick={() => navigate("/list-of-members/002")}>
                    <h3>
                      <span className="metric-number" data-target="32000">0</span>+
                    </h3>
                    <h4 className="metric-title">Valuers</h4>
                    <p className="metric-description">
                      strengthening their professional standing
                    </p>
                  </div>
                  <div className="metric-card" onClick={() => navigate("/branches")}>
                    <h3 className="metric-number" data-target="47">
                      0
                    </h3>
                    <h4 className="metric-title">Branches </h4>
                    <p className="metric-description">
                      through which IOV has been able to establish its PAN-India
                      presence.
                    </p>
                  </div>
                  <div className="metric-card" onClick={() => navigate("/list-of-members/002", { state: { member_type: 2 } })}>
                    <h3>
                      <span className="metric-number" data-target="20000">0</span>+
                    </h3>
                    <h4 className="metric-title">Life Members</h4>
                    <p className="metric-description">
                      aiding Valuers to update their knowledge for future
                      prospects.
                    </p>
                  </div>
                  <div className="metric-card" onClick={() => navigate("/page/council")}>
                    <h3 className="metric-number" data-target="23">
                      0
                    </h3>
                    <h4 className="metric-title">Council Members</h4>
                    <p className="metric-description">
                      An independent group of individuals representing
                      demographic diversity, but united by Valuation
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Experties;
